import addDays from "date-fns/addDays";

export class CustomDate {
  year = 0;
  month = 0;
  day = 0;

  public static ToDate(tnADate: CustomDate | null): Date | null {
    const result = tnADate ? new Date(tnADate.year, tnADate.month - 1, tnADate.day) : null;

    return result;
  }

  public static ToEndOfDate(tnADate: CustomDate | null): Date | null {
    const result = tnADate ? new Date(tnADate.year, tnADate.month - 1, tnADate.day, 23, 59, 59) : null;
    return result;
  }
  public static ToNextDate(tnADate: CustomDate | null): Date | null {
    const dayAfter = tnADate ? addDays(CustomDate.ToDate(tnADate) as Date, 1) : null;
    return dayAfter;
  }

  public static FromDate(date: Date): CustomDate {
    const isUTC = date instanceof Date && date.toDateString().includes("Z");
    return {
      year: isUTC ? date.getUTCFullYear() : date.getFullYear(),
      month: isUTC ? date.getUTCMonth() + 1 : date.getMonth() + 1,
      day: isUTC ? date.getUTCDate() : date.getDate(),
    } as CustomDate;
  }

  public static NewCustomDate(year: number, month: number, day: number): CustomDate {
    return {
      year,
      month,
      day,
    } as CustomDate;
  }
}
